import { PersonIcon } from "@primer/octicons-react";
import { Box } from '@primer/react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { foDangKyAnBanTruApi } from '../../../api/foDangKyAnBanTruApi';
import { Infomation } from '../../../components/hoc-sinh/HocSinhRender';
import HocSinhShortInfo from '../../../components/hoc-sinh/HocSinhShortInfo';
import DataTable from '../../../components/ui/data-table';
import Text from '../../../components/ui/text';
import TextWithEllipse from '../../../components/ui/text-with-ellipse';
import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';
import { IBanTruResponse } from '../../../models/response/crm-hocsinh/IBanTruResponse';
import { IDangKyAnBanTru } from '../../../models/response/dang-ky-an-ban-tru/IDangKyAnBanTru';

export interface BanTruProps {
    ts_hocsinh_id: number;
}

const BanTruPage = (props: BanTruProps) => {
    const [banTrus, setBanTrus] = useState<IBanTruResponse[]>([]);
    const [caAns, setCaAns] = useState<any>();
    const { nam_hoc } = useCommonSelectedHook();
    const [dangKys, setDangKys] = useState<IDangKyAnBanTru[]>([]);
    useEffect(() => {
        handleReload();
    }, [props.ts_hocsinh_id]);

    const handleReload = () => {
        const loadAllHocSinh = async () => {
            const res = await foDangKyAnBanTruApi.select_by_hocsinh(nam_hoc, props.ts_hocsinh_id);
            if (res.is_success) {
                setDangKys(res.data);
            }
        };

        loadAllHocSinh();
    }

    return (
        <Box sx={{ padding: 0 }}>
            <Box sx={{ display: "flex", gap: 3 }}>
                <Box sx={{ flex: 1 }}>
                    <DataTable
                        data={dangKys}
                        height={`${window.innerHeight - 400}px`}
                        actionComponent={
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 2,
                                }}
                            >

                            </Box>
                        }
                        columns={[
                            {
                                dataField: "trang_thai",
                                caption: "Trạng thái",
                                width: "100px",
                                align: "center",
                                cellRender: (data: IDangKyAnBanTru) => {
                                    let trangThai = '';
                                    let bgColor = '';

                                    if (data.trang_thai === 0) {
                                        trangThai = 'Chờ duyệt';
                                        bgColor = '#fdd2b4';
                                    } else if (data.trang_thai === 1) {
                                        trangThai = 'Đã duyệt';
                                        bgColor = '#dafbe1';
                                    } else if (data.trang_thai === 2) {
                                        trangThai = 'Huỷ duyệt';
                                        bgColor = '#ffcdcd';
                                    }
                                    return (
                                        <Box
                                            style={{
                                                display: 'inline-block',
                                                padding: '2px 8px',
                                                borderRadius: '8px',
                                                backgroundColor: bgColor,
                                                fontSize: '0.9rem',
                                                fontWeight: 500,
                                            }}
                                        >
                                            {trangThai}
                                        </Box>
                                    )
                                }
                            },
                            {
                                dataField: "trang_thai_hs",
                                width: "100px",
                                caption: "Trạng thái hs",
                                fixed: true,
                                isMainColumn: true,
                                cellRender: (data: IDangKyAnBanTru) => {
                                    let color: any = "fg.default";
                                    switch (data.trang_thai_hs) {
                                        case "New Enrollment":
                                            color = "accent.emphasis";
                                            break;
                                        case "Thôi học":
                                            color = "danger.emphasis";
                                            break;
                                        case "Học sinh lên lớp chưa đóng phí":
                                            color = "attention.emphasis";
                                            break;

                                        default:
                                            break;
                                    }
                                    return (
                                        <Box
                                            sx={{
                                                color: color,
                                            }}
                                        >
                                            <TextWithEllipse text={data.trang_thai_hs} lineNumber={1} />
                                        </Box>
                                    );
                                },
                            },
                            {
                                dataField: "ma_kh",
                                caption: "Mã KH",
                                width: "80px"
                            },
                            {
                                dataField: "ma_hs",
                                caption: "Mã HS",
                                width: "110px"
                            },
                            {
                                dataField: "ho_ten",
                                width: "200px",
                                caption: "Học sinh",
                                cellRender: (data: IDangKyAnBanTru) => {
                                    const infos: Infomation[] = [
                                        {
                                            title: "",
                                            data: data.ho_ten,
                                            icon: <PersonIcon size={14} />,
                                            fontWeight: "500",
                                        }
                                    ];
                                    return (
                                        <HocSinhShortInfo data={data} />
                                    );
                                },
                            },
                            {
                                caption: "Trường lớp",
                                width: "150px",
                                cellRender: (data: IDangKyAnBanTru) => {
                                    return (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "baseline",
                                                // fontWeight: 600
                                            }}
                                        >
                                            <Box sx={{ display: "flex" }}>
                                                <Box sx={{ fontWeight: 600 }}>{data.ten_lop}</Box>
                                            </Box>
                                            <Box sx={{ color: "fg.muted" }}>
                                                {data.ten_khoi}, {data.ten_he}
                                            </Box>
                                        </Box>
                                    );
                                },
                            },
                            {
                                caption: "Mã bán trú",
                                width: "150px",
                                cellRender: (data: IDangKyAnBanTru) => {
                                    return (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "baseline",
                                            }}
                                        >
                                            <Box sx={{ display: "flex" }}>
                                                <Box sx={{ fontWeight: 600 }}>{data.ma_ban_tru}</Box>
                                            </Box>
                                            <Box sx={{ color: "fg.muted" }}>
                                                {data.ten_ban_tru}
                                            </Box>
                                        </Box>
                                    );
                                }
                            },
                            {
                                dataField: "ngay_bat_dau",
                                caption: "Ngày bắt đầu ăn",
                                width: "110px",
                                cellRender: (data: IDangKyAnBanTru) => {
                                    return (
                                        <Text text={moment(data.ngay_bat_dau).format("DD/MM/YYYY")} />
                                    )
                                },
                            },
                            {
                                dataField: "ghi_chu",
                                caption: "Ghi chú",
                                width: "200px",
                            },
                        ]}
                        title="Thông tin đăng ký ăn bán trú"
                        searchEnable
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default BanTruPage;
